import { api } from "@/api/client";
import { queryKeys } from "@/api/queryKeys";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import type { GetUsersRequestPayload, GetUsersResponse } from "./types";

export const useGetUsers = (payload: GetUsersRequestPayload) => {
  return useQuery<GetUsersResponse>({
    queryKey: [queryKeys.getUsers, payload],
    queryFn: async () => api.post("/admin/get-users", payload).then((res) => res.data),
  });
};

export const useGetInfinityUsers = (payload: Omit<GetUsersRequestPayload, "page">) => {
  return useInfiniteQuery<GetUsersResponse>({
    queryKey: [queryKeys.getUsers, "infinite", payload],
    queryFn: async ({ pageParam = 1 }) =>
      api.post("/admin/get-users", { ...payload, page: pageParam }).then((res) => res.data),
    getNextPageParam: (lastPage) => {
      const totalPages = Math.ceil(lastPage.pagination.total / lastPage.pagination.pageSize);
      if (lastPage.pagination.page < totalPages) {
        return lastPage.pagination.page + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
  });
};
